﻿import LandingPage from "./Registration/LandingPage.svelte";
import PersonalDetails from "./Registration/PersonalDetails.svelte";
import ActionSpecific from "./Registration/ActionSpecific.svelte";
import Employment from "./Registration/Employment.svelte";
import EmploymentDetails from "./Registration/EmploymentDetails.svelte";
import AdditionalDetails from "./Registration/AdditionalDetails.svelte";

const confirmationPages = [
	{
		pageIndex: 0,
		component: LandingPage,
		routeId: "/Registration",
		showInConfirmation: true,
		confirmationHeading: null
	},
	{
		pageIndex: 1,
		component: PersonalDetails,
		routeId: "/Registration/PersonalDetails",
		showInConfirmation: true,
		confirmationHeading: "Your details"
	},
	{
		pageIndex: 2,
		component: Employment,
		routeId: "/Registration/Employment",
		showInConfirmation: true,
		confirmationHeading: "Employment"
	},
	{
		pageIndex: 3,
		component: EmploymentDetails,
		routeId: "/Registration/Employment/:slug",
		showInConfirmation: true,
		loopOver: true,
		confirmationHeading: "Employment Details"
	},
	{
		pageIndex: 4,
		component: AdditionalDetails,
		routeId: "/Registration/AdditionalDetails",
		showInConfirmation: true,
		confirmationHeading: "Additional details"
	}
];

export default confirmationPages;
